import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-120">
      <div className="max-w-4xl mx-auto text-center" data-id="element-121">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-122">
          <span className="text-4xl" data-id="element-123">🤾</span> EDULABS™ Handball
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-124">
          Recursos de excelencia para apasionados del balonmano.
        </p>
        <p className="text-white/50 text-sm italic mb-10" data-id="element-125">
          Porque entrenar handball no debería costarte todas las noches de la
          semana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/70 mb-10" data-id="element-126">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-127">
            <span data-id="element-128">📧</span> soporte.edulabs@gmail.com
          </span>
          <span className="hidden sm:inline text-white/20" data-id="element-129">•</span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-130">
            <span data-id="element-131">📲</span> @edulabs.oficial
          </span>
          <span className="hidden sm:inline text-white/20" data-id="element-132">•</span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-133">
            <span data-id="element-134">🌐</span> www.edulabs.online
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-135" />

        <p className="text-white/30 text-xs tracking-wider" data-id="element-136">
          © EDULABS™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}